import { render, staticRenderFns } from "./UPEIBuffersPreLab.vue?vue&type=template&id=4c419da2&"
import script from "./UPEIBuffersPreLab.vue?vue&type=script&lang=js&"
export * from "./UPEIBuffersPreLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports